import { useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";
import "./Login.css";

export default function ForgotPassword() {
  const [email, setEmail]       = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState("");

  const handleSubmit = async e => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSubmitted(true);
    } catch {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-left">
        <div className="login-brand">
          <div className="login-logo-mark">⬡</div>
          <div>
            <div className="login-brand-name">CommPro</div>
            <div className="login-brand-sub">Powered by Rosegate</div>
          </div>
        </div>
        <div className="login-hero-text">
          <h1>Commission management,<br/><span>simplified.</span></h1>
          <p>Track loans, manage commissions, and handle exceptions — all in one place built for mortgage professionals.</p>
        </div>
      </div>

      <div className="login-right">
        <div className="login-card">
          {submitted ? (
            <>
              <h2>Check your email</h2>
              <p className="login-card-sub">
                If <strong>{email}</strong> is on file, we've sent a password reset link.
                Check your inbox — the link expires in 1 hour.
              </p>
              <Link to="/login" className="btn-primary login-btn" style={{ display: "block", textAlign: "center", marginTop: "24px", textDecoration: "none" }}>
                Back to Sign In
              </Link>
            </>
          ) : (
            <>
              <h2>Forgot your password?</h2>
              <p className="login-card-sub">Enter your email and we'll send you a reset link.</p>

              <form onSubmit={handleSubmit} className="login-form">
                {error && <div className="login-error">{error}</div>}

                <div className="form-group">
                  <label>Email Address</label>
                  <input
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="you@rosegate.com"
                    required autoFocus
                  />
                </div>

                <button type="submit" className="btn-primary login-btn" disabled={loading}>
                  {loading ? "Sending..." : "Send Reset Link →"}
                </button>
              </form>

              <p style={{ textAlign: "center", marginTop: "20px", fontSize: "14px", color: "var(--text-muted)" }}>
                <Link to="/login" style={{ color: "var(--primary)" }}>Back to Sign In</Link>
              </p>
            </>
          )}
        </div>

        <p className="login-footer">
          © {new Date().getFullYear()} Rosegate Mortgage · CommPro
        </p>
      </div>
    </div>
  );
}
